import * as _ from 'lodash';
import React, { Component } from 'react';
import { Grid, Form } from 'semantic-ui-react';
import { reduxForm, getFormValues } from 'redux-form';
import { withRouter } from 'react-router';
import { connect } from 'react-redux';

import { DCImportFieldEnum as Fields } from 'Common/FieldEnum';
import { DC_IMPORT_SETTINGS_FORM } from 'Common/FormEnum';
import { FileImportHeaderMapGrid, TitledCard } from 'Components';
import { postImportFile, clearImportFile } from '../../state/common/actions';
import {
  HeaderOptions,
  DelimOptions,
  MatchOptions,
  IgnoreStateNumberLeadingZerosOptions,
  MatchTypeEnum,
} from '../../helpers/Constants';
import { createToast, toastType } from 'Common/ToastHelper';
import { ReduxFormButtonGroup } from 'Components/forms/ReduxFormButtonGroup';
import { isNullOrUndefined } from 'util';
import { resetDirty } from 'State/dirtyTracking/actions';
import { YesNoOptions } from 'Common/FormHelper';

class FileConfigForm extends Component {
  componentDidMount() {
    //Register fields that are not on the form
    this.props.change(
      Fields.HeaderMapping,
      this.props.initialValues
        ? this.props.initialValues[Fields.HeaderMapping]
        : []
    );
    this.props.change(
      Fields.FileName,
      this.props.initialValues ? this.props.initialValues[Fields.FileName] : ''
    );
    this.props.change(
      Fields.FileLength,
      this.props.initialValues ? this.props.initialValues[Fields.FileLength] : 0
    );

    this.props.resetDirty();
  }

  componentDidUpdate(prevProps) {
    const { fileData, change } = this.props;

    if (prevProps.fileData !== fileData && fileData && fileData.length > 0) {
      change(Fields.FileLength, fileData.length);

      if (fileData[0].length === 1) {
        createToast(
          toastType.warning,
          'Warning',
          'Only one column found. You may be using the wrong delimiter.'
        );
      }
    }
  }

  getFileData = () => {
    const { formValues } = this.props;
    let fileData = _.cloneDeep(this.props.fileData);
    if (formValues[Fields.HeaderMapping] && fileData[0]) {
      while (formValues[Fields.HeaderMapping].length > fileData[0].length) {
        fileData[0].push(null);
      }
    }

    return fileData;
  };

  handleHeaderChange = headers => {
    this.props.change(Fields.HeaderMapping, headers);
  };

  onFileUpload = (file, delim) => {
    this.props.change(Fields.FileName, file.name);
    this.props.postImportFile(file, delim);
  };

  render = () => {
    const {
      loading,
      dispatch,
      formValues,
      clearImportFile,
      fileName,
      getRequiredHeaders,
      getDisabledHeaders,
    } = this.props;

    return (
      <Form name={DC_IMPORT_SETTINGS_FORM}>
        <Grid>
          <Grid.Row>
            <Grid.Column>
              <TitledCard title={'File Format Settings'}>
                <Grid>
                  <Grid.Row columns={2}>
                    <Grid.Column width={6} className="input-group--btn-group">
                      <ReduxFormButtonGroup
                        dispatch={dispatch}
                        formName={DC_IMPORT_SETTINGS_FORM}
                        fieldName={Fields.Delimiter}
                        options={DelimOptions}
                        label={'File Delimiter'}
                        value={
                          formValues &&
                          !isNullOrUndefined(formValues[Fields.Delimiter])
                            ? formValues[Fields.Delimiter]
                            : ','
                        }
                        disabled={loading}
                      />
                    </Grid.Column>
                    <Grid.Column className="input-group--btn-group">
                      <ReduxFormButtonGroup
                        dispatch={dispatch}
                        formName={DC_IMPORT_SETTINGS_FORM}
                        fieldName={Fields.MatchOn}
                        options={MatchOptions}
                        label={'Match Students Using'}
                        value={formValues[Fields.MatchOn]}
                        disabled={loading}
                      />
                    </Grid.Column>
                  </Grid.Row>
                  <Grid.Row columns={4}>
                    {formValues[Fields.MatchOn] ===
                      MatchTypeEnum.StateNumber && (
                      <Grid.Column className="input-group--btn-group">
                        <ReduxFormButtonGroup
                          dispatch={dispatch}
                          formName={DC_IMPORT_SETTINGS_FORM}
                          fieldName={Fields.IgnoreStateNumberLeadingZeros}
                          options={IgnoreStateNumberLeadingZerosOptions}
                          label={'Ignore Leading Zeros for State Number'}
                          value={
                            formValues[Fields.IgnoreStateNumberLeadingZeros]
                          }
                          disabled={loading}
                        />
                      </Grid.Column>
                    )}
                    <Grid.Column className="input-group--btn-group">
                      <ReduxFormButtonGroup
                        dispatch={dispatch}
                        formName={DC_IMPORT_SETTINGS_FORM}
                        fieldName={Fields.ContainsHeaderInformation}
                        options={YesNoOptions}
                        label={'File Contains Headers?'}
                        value={
                          formValues &&
                          !isNullOrUndefined(
                            formValues[Fields.ContainsHeaderInformation]
                          )
                            ? formValues[Fields.ContainsHeaderInformation]
                            : false
                        }
                        disabled={loading}
                      />
                    </Grid.Column>
                    <Grid.Column className="input-group--btn-group">
                      <ReduxFormButtonGroup
                        dispatch={dispatch}
                        formName={DC_IMPORT_SETTINGS_FORM}
                        fieldName={Fields.UseAddressInFile}
                        options={YesNoOptions}
                        label={'Use Address From File?'}
                        value={
                          formValues &&
                          !isNullOrUndefined(
                            formValues[Fields.UseAddressInFile]
                          )
                            ? formValues[Fields.UseAddressInFile]
                            : false
                        }
                        disabled={loading}
                      />
                    </Grid.Column>
                    <Grid.Column className="input-group--btn-group">
                      <ReduxFormButtonGroup
                        dispatch={dispatch}
                        formName={DC_IMPORT_SETTINGS_FORM}
                        fieldName={Fields.CreateFamilies}
                        options={YesNoOptions}
                        label={'Automatically group families?'}
                        value={
                          formValues &&
                          !isNullOrUndefined(formValues[Fields.CreateFamilies])
                            ? formValues[Fields.CreateFamilies]
                            : false
                        }
                        disabled={loading}
                      />
                    </Grid.Column>
                  </Grid.Row>
                </Grid>
              </TitledCard>
            </Grid.Column>
          </Grid.Row>
          <Grid.Row>
            <Grid.Column>
              <FileImportHeaderMapGrid
                onFileUpload={this.onFileUpload}
                fileData={this.getFileData()}
                fileName={fileName}
                headerOptions={HeaderOptions}
                clearData={clearImportFile}
                delimiter={formValues ? formValues[Fields.Delimiter] : ','}
                defaultHeaders={formValues[Fields.HeaderMapping]}
                loading={loading}
                onHeaderChange={this.handleHeaderChange}
                title={'Map Column Data'}
                requiredHeaders={getRequiredHeaders(formValues)}
                disabledHeaders={getDisabledHeaders(formValues)}
              />
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </Form>
    );
  };
}

const mapStateToProps = state => {
  return {
    formValues: getFormValues(DC_IMPORT_SETTINGS_FORM)(state),
    fileName: state.DCImportState.common.fileName,
  };
};

const mapDispatchToProps = {
  postImportFile,
  clearImportFile,
  resetDirty,
};

FileConfigForm = withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(FileConfigForm)
);

FileConfigForm = reduxForm({
  form: DC_IMPORT_SETTINGS_FORM,
})(FileConfigForm);

export { FileConfigForm };



// WEBPACK FOOTER //
// ./src/pages/dcimport/components/fileconfig/FileConfigForm.js